var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShirt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shirt 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2532 3.80468C14.039 3.03778 13.5387 2.43498 12.8723 2.10163C12.8196 2.07528 11.5429 1.56163 10.5662 1.16943L8.19902 4.01108C8.14992 4.07008 8.07697 4.10428 8.00002 4.10428C7.92307 4.10428 7.85012 4.07008 7.80102 4.01108L5.43387 1.16943C4.45712 1.56163 3.18047 2.07528 3.12772 2.10163C2.46137 2.43493 1.96107 3.03773 1.74687 3.80468L1.00097 12.6413C0.994369 12.7175 1.02172 12.7925 1.07592 12.8464C1.45977 13.2299 1.96917 13.4411 2.51097 13.4411H2.81477C2.94542 13.4411 3.05582 13.3436 3.07202 13.2139L3.93862 6.27848C4.04897 6.87138 4.11107 7.47258 4.11107 8.07898V14.2389C4.11107 14.3547 4.18802 14.4565 4.29892 14.4884C5.49247 14.8293 6.74627 14.9998 8.00002 14.9998C9.25377 14.9998 10.5076 14.8293 11.7011 14.4884C11.812 14.4565 11.8889 14.3547 11.8889 14.2389V8.07898C11.8889 7.47258 11.951 6.87133 12.0614 6.27848L12.928 13.2139C12.9442 13.3436 13.0546 13.4411 13.1852 13.4411H13.489C14.0308 13.4411 14.5402 13.2299 14.9241 12.8464C14.9783 12.7925 15.0056 12.7175 14.999 12.6413L14.2532 3.80468Z",
    fill: "#808080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt2);
export default __webpack_public_path__ + "static/media/shirt 2.590a12086b0cc7fba03d1097540e3bb3.svg";
export { ForwardRef as ReactComponent };